import React from "react";
import { useSelectFilterContext } from "../SelectFilter.context";
var Option = function (_a) {
    var name = _a.name, value = _a.value, disabled = _a.disabled;
    var _b = useSelectFilterContext(), onChangeOption = _b.onChangeOption, onKeyDownOption = _b.onKeyDownOption;
    return (React.createElement("li", { className: "ssg-select-filter__option-checkbox-option", onClick: function (e) { return onChangeOption(e, value); }, "data-value": value, onKeyDown: function (e) { return onKeyDownOption(e, value); }, tabIndex: 0, "aria-disabled": disabled !== null && disabled !== void 0 ? disabled : false }, name));
};
export default Option;
